<template>
  <div :class="$style.featureTitleContainer">
    <h3>
      {{ $textDictionary['pdp.feature.title.label'] ?? 'Feature Title' }}
    </h3>
    <p v-if="documentationUrl">
      {{ $textDictionary['pdp.feature.moreFeatureInfo.label'] ?? '' }}
      <a :href="documentationUrl" target="_blank">{{
        $textDictionary['pdp.feature.moreFeatureInfoLinkText.label'] ?? ''
      }}</a>
    </p>
  </div>
  <ClientOnly>
    <ProductFeatures
      :groups="productFeatureGroup"
      :documentation-url-slug="documentationUrlSlug"
    />
  </ClientOnly>
</template>

<script setup lang="ts">
import type { FeatureGroup, FeatureTableValue } from './ProductFeatures.vue';
import ProductFeatures from './ProductFeatures.vue';
import { useProductDetailPageStore } from '~/stores/productDetailPageStore/productDetailPageStore';

const store = useProductDetailPageStore();
const { $textDictionary } = useNuxtApp();

const productFeatureGroup = computed<FeatureGroup[]>(() => {
  return (
    store.decoratedProduct?.renderFeatureAttributes()?.map((f) => ({
      title:
        $textDictionary.value[`pdp.feature.${ensureArray(f.key)}.label`] ??
        f.key,
      items: 'items?',
      features: f.items.map<FeatureTableValue>((item) => ({
        label: item.label,
        description: item.description,
        value: item.value.toString()
      }))
    })) ?? []
  );
});

const documentationUrl = computed(
  () => store.decoratedProduct?.productDocumentationLink ?? null
);
const documentationUrlSlug = computed(
  () => store.decoratedProduct?.productDocumentationLinkSlug ?? ''
);
</script>

<style scoped module>
.featureTitleContainer {
  padding-bottom: 5px;
}
</style>
